import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { Observable } from 'rxjs';
import { UserDataService } from './../../../../../src/app/DataServices/user-data.service';
import { BaseService } from './base.service';
@Injectable({
    providedIn: 'root'
})
export class AuthGuardService  {

    constructor(
        private baseService: BaseService,
        private msalService: MsalService,
        private userService: UserDataService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
        : boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        const url = route.url;
        if (this.userService.currentUserValue === undefined) {
            this.userService.GetUserDetails().then(response => {
                this.userService.userDetails = response;
                return true;
            });
            return true;
        } else if (this.userService.currentUserValue !== null) {
            return true;
        } else {
            //  this.router.navigate(['/auth/login']);
            return this.userService.routeUnAuthorizedAccess();

        }
    }

}
